import SectionReveal from "@/components/SectionReveal";
import { Database, KeyRound, Network, Server, ShieldCheck } from "lucide-react";

const stages = [
  { label: "Untrusted activity", detail: "User, device or network request", icon: Network },
  { label: "Verify identity", detail: "Identity, device and route context", icon: KeyRound },
  { label: "Apply policy", detail: "QuantumCloak access decision", icon: ShieldCheck, boundary: true },
  { label: "Protected service", detail: "Approved infrastructure surface", icon: Server },
  { label: "Operational evidence", detail: "State and context in QuantumCubeDB", icon: Database },
];

export default function TrustBoundaryDiagram({ dark = false }) {
  return (
    <SectionReveal as="figure" className={`lf-trust-boundary lf-signal-diagram ${dark ? "lf-trust-boundary-dark" : ""}`} aria-labelledby="trust-boundary-caption">
      <figcaption id="trust-boundary-caption">
        <span>Trust boundary · request path</span>
        <span>Verify before protected access</span>
      </figcaption>
      <ol>
        {stages.map(({ label, detail, icon: Icon, boundary }, index) => (
          <li key={label} className={boundary ? "lf-trust-boundary-gate" : ""}>
            {boundary ? <span className="lf-boundary-label">Policy boundary</span> : null}
            <span className="lf-trust-index">0{index + 1}</span>
            <Icon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" />
            <strong>{label}</strong>
            <small>{detail}</small>
          </li>
        ))}
      </ol>
      <p>Only approved requests continue to protected services; operational state remains visible for review and governed response.</p>
    </SectionReveal>
  );
}
